import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getWordmarkAsset } from "@/constants/assets";
import { ROUTES } from "@/constants/navigation";
import { useTheme } from "@/hooks/useTheme";
import { FOOTER_BRAND_TAGLINE_KEY } from "@/components/Layout/footer/footerData";
import "./FooterBrand.css";

export function FooterBrand() {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <div className="site-footer__brand-col">
      <Link to={ROUTES.home} className="site-footer__logo">
        <img
          src={getWordmarkAsset(theme)}
          alt={t("brand")}
          width={281}
          height={60}
          loading="lazy"
        />
      </Link>
      <p className="site-footer__tagline muted">
        {t(FOOTER_BRAND_TAGLINE_KEY)}
      </p>
    </div>
  );
}
